import Submit from 'shared/components/Submit';
import Button from 'shared/components/buttons/Button';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';

const CancelButton = ({cancelCaption, onCancel, preventDefault, enabled}) => {
  const handleCancel = e => {
    if (preventDefault) {
      e.preventDefault();
    }
    onCancel(e);
  };

  return (
    <Button className='ModalCancelButton mr1' disabled={!enabled} trait='default' type='button' onClick={handleCancel}>
      <FormattedMessage id={cancelCaption}/>
    </Button>
  );
};

const SaveButton = observer(({saveCaption, onSave, enabled, staysDisabledAfterClick, trait}) => {
  return (
    <Submit
      className='ModalSaveButton ml1'
      disabled={!enabled}
      onClick={onSave}
      staysDisabledAfterClick={staysDisabledAfterClick}
      trait={trait}
    >
      <FormattedMessage id={saveCaption}/>
    </Submit>
  );
});

const ModalButtons = observer(({
  children,
  cancelCaption = 'Cancel',
  saveCaption = 'Save',
  onSave = () => {},
  onCancel = () => {},
  enabled = true,
  staysDisabledAfterClick = false,
  trait = 'primary',
  saveEnabled = true,
  hideSave,
  className
}) => {
  return (
    <div className={`ModalButtons clearfix ${className ? className : 'mt3'}`}>
      {children}
      <CancelButton cancelCaption={cancelCaption} onCancel={onCancel} enabled={enabled}/>
      {!hideSave && <SaveButton
        saveCaption={saveCaption}
        onSave={onSave}
        enabled={enabled && saveEnabled}
        staysDisabledAfterClick={staysDisabledAfterClick}
        trait={trait}
      />}
    </div>
  );
});

export default ModalButtons;
